export default __webpack_public_path__ + "static/removingShoes-4d0c0b930719e2de6f18b911002f4031.svg";